export const TOAST_KEY = 'appraiser_toast';


export interface IToaster {
  summary?: string;
  detail?: any;
  id?: any;
  life?: number;
  sticky?: boolean;
  closable?: boolean;
  data?: any;
  icon?: string;
  contentStyleClass?: string;
  styleClass?: string;
  closeIcon?: string;
}
